"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExecution = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
/**
 * When caller desires just data series and no slicing, create a single-dim result.
 */
function seriesOnlyDim(seriesBy) {
    return [
        sdk_model_1.newDimension(compact_1.default(tslib_1.__spread(seriesBy.filter(sdk_model_1.isAttribute), [
            // only include MeasureGroupIdentifier if there are some measures, otherwise the execution will always fail on the backend
            seriesBy.some(sdk_model_1.isMeasure) && sdk_model_1.MeasureGroupIdentifier,
        ]))),
    ];
}
/**
 * When caller desires data series to be sliced further by some attributes (and perhaps with totals as well)
 * then create two-dim result resembling a pivot table:
 *
 * -  slices are in rows (first dim)
 * -  measures & scoping attributes will be in columns (second dim)
 */
function seriesAndSlicesDim(seriesBy, slices, totals) {
    return sdk_model_1.newTwoDimensional(tslib_1.__spread(slices, totals), compact_1.default(tslib_1.__spread(seriesBy.filter(sdk_model_1.isAttribute), [
        // only include MeasureGroupIdentifier if there are some measures, otherwise the execution will always fail on the backend
        seriesBy.some(sdk_model_1.isMeasure) && sdk_model_1.MeasureGroupIdentifier,
    ])));
}
/**
 * Given execute props, this will prepare execution to send to backend.
 *
 * @param options - create execution options
 * @internal
 */
function createExecution(options) {
    var _a, _b;
    var backend = options.backend, workspace = options.workspace, _c = options.seriesBy, seriesBy = _c === void 0 ? [] : _c, _d = options.slicesBy, slicesBy = _d === void 0 ? [] : _d, _e = options.filters, filters = _e === void 0 ? [] : _e, _f = options.sortBy, sortBy = _f === void 0 ? [] : _f, _g = options.totals, totals = _g === void 0 ? [] : _g, _h = options.componentName, componentName = _h === void 0 ? "Execution" : _h;
    ts_invariant_1.default(backend && workspace, "backend and workspace must be either specified explicitly or be provided by context");
    var dimensions = isEmpty_1.default(slicesBy)
        ? seriesOnlyDim(seriesBy)
        : seriesAndSlicesDim(seriesBy, slicesBy, totals);
    return (_a = (_b = backend
        .withTelemetry(componentName, options)
        .workspace(workspace)
        .execution()
        .forItems(seriesBy.concat(slicesBy), filters))
        .withSorting.apply(_b, tslib_1.__spread(sortBy)))
        .withDimensions.apply(_a, tslib_1.__spread(dimensions));
}
exports.createExecution = createExecution;
//# sourceMappingURL=createExecution.js.map